import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  LoadDefinitions,
  LoadDefinitionById,
  SaveDefinition,
  SaveDefinitions,
  AddNewDefinitions,
  DeleteDefinition,
  GetTypeDefinitionRemarkContents,
  UpdateTypeDefinitionRemarkContents,
  GetWageSupplementTypes,
  GetWageSupplementTimeTypes,
  GetSeasonalTimeTypes,
  GetApplicableDaysTypes,
  SaveDefinitionCompounding,
  GetDefinitionCompounding,
  SaveDefinitionRelevancy,
  GetDefinitionRelevancy,
  GetWorkTypeTypes,
  GetWorkTypeLimitTypes,
};

function LoadDefinitions(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function LoadDefinitionById(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  wageSupplementTypeDefinitionId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions/${wageSupplementTypeDefinitionId}`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function SaveDefinition(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  wageSupplementTypeDefinitionId,
  worktimesObject,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions/${wageSupplementTypeDefinitionId}`,
      worktimesObject,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveDefinitions(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  worktimesObject,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions`,
      worktimesObject,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetDefinitionCompounding(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions/compoundsupplements`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveDefinitionCompounding(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  compoundsupplements,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions/compoundsupplements` +
        (compoundsupplements
          ? `?shouldCompundWageSupplements=${compoundsupplements}`
          : ""),
      null,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetDefinitionRelevancy(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions/typeRelevancy`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveDefinitionRelevancy(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  typeRelevancy,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions/typeRelevancy`,
      typeRelevancy,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function AddNewDefinitions(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  worktimesObject,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions`,
      worktimesObject,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteDefinition(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  wageSupplementTypeDefinitionId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions/${wageSupplementTypeDefinitionId}`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetTypeDefinitionRemarkContents(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  wageSupplementTypeDefinitionId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions/${wageSupplementTypeDefinitionId}` +
        `/remarkContents`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UpdateTypeDefinitionRemarkContents(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  wageSupplementTypeDefinitionId,
  remarkContents,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}` +
        `/wagesupplementtypedefinitions/${wageSupplementTypeDefinitionId}` +
        `/remarkContents`,
      remarkContents,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetWageSupplementTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/enumlist/wagesupplementtype`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function GetWageSupplementTimeTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/enumlist/wagesupplementtimetype`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function GetSeasonalTimeTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/enumlist/seasonaltimetypes`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function GetApplicableDaysTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/enumlist/applicabledaystypes`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function GetWorkTypeTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/enumlist/wagesupplementworktypes`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function GetWorkTypeLimitTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/enumlist/wagesupplementworktypelimittypes`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}
